export default class BuildingInfo {
  constructor(
    buildingId,
    serverId,
    cloudServerId = null,
    localAddress,
    buildingName,
    modules = [],
    code = ""
  ) {
    this.buildingId = buildingId;
    this.serverId = serverId;
    this.cloudServerId = cloudServerId;
    this.localAddress = localAddress;
    this.buildingName = buildingName;
    this.modules = modules;
    this.code = code;
  }

  static parse(obj) {
    var result = new BuildingInfo();
    Object.assign(result, obj);
    return result;
  }
}
